@if (visible()) {
  <div class="earnings-overview" [class.desktop]="isDesktop()">
    <app-v3-overview-card-header
      icon="/v3/earnings.svg"
      title="Earnings"
      [updatedAt]="updatedAt()"
      actionLabel="Alle Earnings"
      (navigate)="onNavigate()"
    ></app-v3-overview-card-header>

    @if (isDesktop()) {
      <app-v3-earnings-desktop-content></app-v3-earnings-desktop-content>
    } @else {
      @if (isFinnet() && reportPeriod()) {
        <p class="report-period">{{ reportPeriod() }}</p>
      }

      <app-eps-chart [data]="epsData()" [v3]="true" [animateIn]="true" [steps]="3"></app-eps-chart>

      @if (earningsTitle()) {
        <div class="earnings-title">
          <span class="notch"></span>
          <p class="earnings-title-text">{{ earningsTitle() }}</p>
        </div>
      }

      @if (isFinnet()) {
        <button class="earnings-details" type="button" (click)="onNavigate()">
          <span>Earnings-Analyse</span>
          <span class="caret"></span>
        </button>
      }
    }
  </div>
}
